/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Grid,
  Typography,
  Collapse,
  Button,
  IconButton,
  Box,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import { WrappedFieldArrayProps } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { Cancel, CheckCircle } from '@material-ui/icons';
import FormSlider from 'components/FormSlider';
import {
  getMinValue,
  getMaxValue,
} from 'containers/ItaIllustrationPage/helper';
import FormBooleanOption from 'components/FormBooleanOption';
import { formatMonetaryValue } from 'helpers/math';
import IconPencilBlue from 'images/pencil-light-blue.svg';
import FormNumberField from 'components/FormNumberField';
import messages from '../../messages';

const Benefits = ({
  fields,
  coverages,
  itaConfig,
  currency,
  isInsuredTwo,
  editData,
  changeEditData,
  calculateEditData,
  change,
  inactive,
  isCoveragesError,
}) => {
  const theme = useTheme();

  return (
    <Box bgcolor={inactive ? `#f2f2f2` : undefined}>
      {fields.map((benefit, index) => {
        if (!coverages[index].selected) {
          return null;
        }
        let isValidData = coverages[index].selected;

        if (coverages[index].id === 'WOP') {
          if (isInsuredTwo)
            isValidData =
              coverages[index].valueInsuredOne &&
              coverages[index].valueInsuredTwo;
          else isValidData = coverages[index].valueInsuredOne;
        }

        return (
          <Box
            key={index}
            bgcolor={inactive ? '#f2f2f2' : undefined}
            pl={3}
            pr={1}
            py={2}
            borderBottom={`1px solid ${theme.palette.divider}`}
          >
            <Grid container alignItems="center" spacing={1} wrap="nowrap">
              <Grid item>
                <Grid container alignItems="center" justify="center">
                  {isValidData ? (
                    <CheckCircle
                      style={{ color: theme.palette.success.main }}
                    />
                  ) : (
                    <Cancel style={{ color: theme.palette.error.main }} />
                  )}
                </Grid>
              </Grid>

              <Grid item xs>
                <Typography
                  variant="body1"
                  style={{
                    fontWeight: 700,
                  }}
                >
                  {coverages[index].title}
                </Typography>
              </Grid>

              <Grid item xs={3}>
                <Grid
                  container
                  alignItems="center"
                  justify="space-between"
                  wrap="nowrap"
                >
                  <Grid item xs={8}>
                    {editData.editIndex === index &&
                    editData.editInsured !== 0 &&
                    coverages[index].id !== 'WOP' ? (
                      <Field
                        shrink
                        name={`${benefit}.valueInsuredOne`}
                        fullWidth
                        component={FormNumberField}
                        onChange={newVal =>
                          change(`${benefit}.valueInsuredTwo`, newVal)
                        }
                        color="inherit"
                        variant="standard"
                      />
                    ) : (
                      <Typography
                        variant="body1"
                        color="textPrimary"
                        id={`${coverages[index].id}.insuredOne`}
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        {coverages[index].selected
                          ? coverages[index].type === '1'
                            ? formatMonetaryValue(
                                coverages[index].valueInsuredOne,
                                false,
                              )
                            : coverages[index].valueInsuredOne
                            ? 'Yes'
                            : 'No '
                          : '-'}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={4}>
                    {!inactive ? (
                      <IconButton
                        disabled={
                          !coverages[index].selected || isCoveragesError
                        }
                        onClick={() =>
                          changeEditData({
                            editIndex: index,
                            editInsured: 1,
                          })
                        }
                      >
                        <img src={IconPencilBlue} alt="" />
                      </IconButton>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>

              {isInsuredTwo && (
                <Grid item xs={3}>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    spacing={1}
                  >
                    <Grid item xs={8}>
                      <Typography
                        variant="body1"
                        color={
                          coverages[index].id === 'WOP'
                            ? 'textPrimary'
                            : 'textSecondary'
                        }
                        id={`${coverages[index].id}.insuredTwo`}
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        {coverages[index].selected
                          ? coverages[index].type === '1'
                            ? formatMonetaryValue(
                                coverages[index].valueInsuredTwo,
                                false,
                              )
                            : coverages[index].valueInsuredTwo
                            ? 'Yes'
                            : 'No '
                          : '-'}
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      {!inactive &&
                        (coverages[index].id === 'WOP' ? (
                          <IconButton
                            disabled={coverages[index].id != 'WOP'}
                            onClick={() =>
                              changeEditData({
                                editIndex: index,
                                editInsured: 2,
                              })
                            }
                          >
                            <img src={IconPencilBlue} alt="" />
                          </IconButton>
                        ) : null)}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>

            <Collapse
              in={editData.editIndex === index && editData.editInsured != 0}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
                justify="space-between"
              >
                <Grid item xs={7}>
                  {editData.editInsured === 1 ? (
                    coverages[index].type === '1' ? (
                      <Field
                        name={`${benefit}.valueInsuredOne`}
                        component={FormSlider}
                        id={coverages[index].id}
                        min={getMinValue(
                          coverages[index].id,
                          itaConfig.features,
                          currency,
                        )}
                        max={getMaxValue(
                          coverages[index].id,
                          itaConfig.features,
                          currency,
                        )}
                        diff={50000}
                        onChange={(e, newVal) => {
                          change(
                            `productConfig.${benefit}.valueInsuredTwo`,
                            newVal,
                          );
                        }}
                        isPrimary={false}
                        type="text"
                      />
                    ) : (
                      <Field
                        name={`${benefit}.valueInsuredOne`}
                        component={FormBooleanOption}
                        type="text"
                        margin="normal"
                        onChange={(e, newVal) => {
                          // change(
                          //   `productConfig.${benefit}.valueInsuredTwo`,
                          //   newVal,
                          // );
                        }}
                        shrink
                        fullWidth
                      />
                    )
                  ) : coverages[index].type === '1' ? (
                    <Field
                      name={`${benefit}.valueInsuredTwo`}
                      component={FormSlider}
                      id={coverages[index].id}
                      min={getMinValue(
                        coverages[index].id,
                        itaConfig.features,
                        currency,
                      )}
                      max={getMaxValue(
                        coverages[index].id,
                        itaConfig.features,
                        currency,
                      )}
                      diff={50000}
                      isPrimary={false}
                      disabled
                      type="text"
                    />
                  ) : (
                    <Field
                      name={`${benefit}.valueInsuredTwo`}
                      component={FormBooleanOption}
                      type="text"
                      margin="normal"
                      disabled={false}
                      shrink
                      fullWidth
                    />
                  )}
                </Grid>

                <Grid item xs={3}>
                  <Button
                    size="large"
                    variant="contained"
                    disabled={isCoveragesError}
                    onClick={() =>
                      calculateEditData({ editIndex: 0, editInsured: 0 })
                    }
                  >
                    <FormattedMessage {...messages.update} />
                  </Button>
                </Grid>
              </Grid>
            </Collapse>
          </Box>
        );
      })}
    </Box>
  );
};

Benefits.propTypes = {
  ...WrappedFieldArrayProps,
  theme: PropTypes.object,
  options: PropTypes.object,
  itaConfig: PropTypes.object,
  currency: PropTypes.string,
  coverages: PropTypes.array.isRequired,
  editData: PropTypes.object,
  changeEditData: PropTypes.func,
  calculateEditData: PropTypes.func,
  isInsuredTwo: PropTypes.bool,
  change: PropTypes.func,
};

export default Benefits;
